// extracted by mini-css-extract-plugin
export var modal = "_4o-0";